export const POSTHOG_ENDPOINTS = {
  FLAGS: "/flags",
} as const;
